/**
 * Disposicoes da lista de cotacoes da corretora (04/11/2026).
 *
 * A lista tinha dez colunas, com as acoes empilhadas em quatro botoes, e rolava para o
 * lado em qualquer tela comum: o status saia cortado. O dono pediu a tela da corretora
 * sem barra de rolagem. Como na lista de operacoes da seguradora
 * (listaDeOperacoesLayout.ts), a largura medida escolhe a disposicao: os dados sao os
 * mesmos, o que muda e como se agrupam na mesma celula, e as acoes ficam num menu na
 * ultima coluna.
 *
 * Com o menu lateral aberto, a area da lista mede perto de 1036 px em 1366 de largura,
 * 1110 em 1440 e 1398 em 1920: as duas primeiras ficam na reunida, e a terceira na
 * ampla.
 */
export type EncaixeDaListaDaCorretora = 'ampla' | 'reunida' | 'estreita' | 'minima';

/** Larguras da area da lista, ja sem menu e margens, em pixels. */
export const LARGURA_DA_CORRETORA_AMPLA = 1340;
export const LARGURA_DA_CORRETORA_REUNIDA = 960;
export const LARGURA_DA_CORRETORA_ESTREITA = 640;

export function encaixarListaDaCorretora(
  disponivel: number,
): EncaixeDaListaDaCorretora {
  // Antes da primeira medida nao ha largura: nada indica que falta espaco.
  if (disponivel <= 0 || disponivel >= LARGURA_DA_CORRETORA_AMPLA) return 'ampla';
  if (disponivel >= LARGURA_DA_CORRETORA_REUNIDA) return 'reunida';
  if (disponivel >= LARGURA_DA_CORRETORA_ESTREITA) return 'estreita';
  return 'minima';
}
